import { isTypeCard } from '@platform/contentful';
import { Entry } from 'contentful';
import ContentfulSmallCta from './ContentfulSmallCta';
import MarkdownText from './util/MarkdownText';

const ContentfulCard = ({
  entry,
}: {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  entry: Entry<any, 'WITHOUT_UNRESOLVABLE_LINKS', 'en-US'> | undefined;
}) => {
  if (!entry || !isTypeCard(entry)) {
    return null;
  }

  return (
    <div className='flex flex-col h-full border border-gray-50 bg-white'>
      {entry.fields.image && (
        <img
          className='w-full max-w-full'
          src={`https://optimole.movingworlds.org/h:225/w:435/rt:fill/q:85/${entry.fields.image.fields.file?.url}?fit=fill&w=435&h=225`}
          alt={entry.fields.image.fields.title}
        />
      )}
      <div className='flex flex-col p-5 text-left h-full'>
        <h5 className='my-3 font-header text-xl sm:text-2xl leading-6 sm:leading-7 font-semibold text-gray-500'>
          {entry.fields.header}
        </h5>
        {entry.fields.headerIcon && <span>Icon: {entry.fields.headerIcon}</span>}
        <MarkdownText text={entry.fields.description} />
        <div className='mt-auto'>
          <ContentfulSmallCta entry={entry.fields.cta} />
        </div>
        {entry.fields.tags?.map((tag, index) => <span key={index}>{tag}</span>)}
        {entry.fields.categories?.map((category, index) => <span key={index}>{category}</span>)}
      </div>
    </div>
  );
};

export default ContentfulCard;
